module.exports = "data:image/gif;base64,R0lGODlhAQASAOMIAN7j5vDz8/P19fX39/f5+fn7+/z8/f3+/v///////////////////////////////ywAAAAAAQASAAAECVAMUsxBOGscAQA7"


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/form/text-bg.gif
 ** module id = 321
 ** module chunks = 0
 **/